import { createFileRoute } from '@tanstack/react-router';
import { PortalLayout } from '../app/layouts/portal-layout';

/** Portal area: active membership required; light / dark by preference. */
export const Route = createFileRoute('/portal')({ component: PortalLayout });
